module.exports = __webpack_public_path__ + "media/images/img_no_image_150-150-944cff5d4611df19a38d8e1f89343ac8.png";